function resolveObject(value) {
  return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
}

function resolveArray(value) {
  return Array.isArray(value) ? value : [];
}

function text(value) {
  return String(value ?? '').trim();
}

function normalizeTabs(tabs = []) {
  return resolveArray(tabs).map((tab, index) => {
    const item = resolveObject(tab);
    return {
      key: text(item.key) || `tab:${index}`,
      label: text(item.label),
    };
  });
}

function selectCurrentRevision({ artifactDocument = {}, revisionEntries = [] } = {}) {
  const entries = resolveArray(revisionEntries).map((item) => resolveObject(item));
  return entries.find((item) => item.is_latest === true)
    || entries[0]
    || resolveObject(resolveObject(artifactDocument).latest_revision);
}

function normalizeUpkeepStatus(value = {}) {
  const item = resolveObject(value);
  const action = resolveObject(item.action);
  const status = {
    actionKey: text(action.action_key || action.type),
    label: text(action.label),
    reason: text(item.reason),
    state: text(item.state),
  };
  return Object.values(status).some(Boolean) ? status : null;
}

function normalizeRevisionControl(value = {}) {
  const item = resolveObject(value);
  return {
    enabled: item.enabled === true,
    revisionId: text(item.revision_id),
    revisionKey: text(item.revision_key || item.key),
  };
}

export function buildCanvasDevDiagnostics({
  activeTabKey,
  artifactDocument,
  revisionControls,
  revisionEntries,
  showCanvasPanel,
  tabs,
} = {}) {
  const document = resolveObject(artifactDocument);
  const currentRevision = selectCurrentRevision({ artifactDocument: document, revisionEntries });
  const normalizedTabs = normalizeTabs(tabs);
  const controls = resolveObject(revisionControls);
  return {
    artifact: {
      currentRevisionId: text(currentRevision.revision_id),
      currentRevisionVersion: text(currentRevision.version),
      id: text(document.artifact_id),
      revisionCount: resolveArray(revisionEntries).length,
      title: text(document.title),
      type: text(document.artifact_type || document.document_kind || document.kind),
      upkeepStatus: normalizeUpkeepStatus(document.upkeep_status),
    },
    canvas: {
      activeTabKey: text(activeTabKey),
      available: normalizedTabs.length > 0,
      showPanel: showCanvasPanel === true,
      tabCount: normalizedTabs.length,
      tabs: normalizedTabs,
    },
    revisionControls: {
      redo: normalizeRevisionControl(controls.redo),
      undo: normalizeRevisionControl(controls.undo),
    },
  };
}

export default buildCanvasDevDiagnostics;
